import type { BreadcrumbNavigationState } from './breadcrumbNavigationReducer';

const EMPTY_PREFERRED_ALIAS_MAP: Record<string, string> = {};

export const selectBreadcrumbNavigationState = (state: any): BreadcrumbNavigationState | undefined =>
    state.getIn(['app', 'breadcrumbNavigation']);

export const selectPreferredAliasIdByBoardId = (state: any): Record<string, string> =>
    selectBreadcrumbNavigationState(state)?.preferredAliasIdByBoardId || EMPTY_PREFERRED_ALIAS_MAP;
